export default __webpack_public_path__ + "images/WK.755e695.png";